import React, { useContext, useEffect, useState } from "react";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { GetAdminActivityLogList } from "../../services/DashBoard/DashBoardApi";
import PaginationComponent from "../../components/common/PaginationModal";

const ActivityLog = () => {
  // Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize, PanalModuleName } = useContext(AuthContext);

  const [logListCount, setlogListCount] = useState(-1);
  const [logList, setlogList] = useState([]);
  const [logListCurrentPage, setlogListCurrentPage] = useState(1);

  useEffect(() => {
    GetAdminActivityLogListData(1);
  }, []);

  const HandlePageChange = async (pageNumber) => {
    setlogListCurrentPage(pageNumber);
    await GetAdminActivityLogListData(pageNumber);
  };

  const GetAdminActivityLogListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetAdminActivityLogList({
        moduleName: PanalModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword: null,
        adminKeyID: authDetails.adminKeyID,
        fromDate: null,
        toDate: null,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data.map((activity) => ({
          date: activity.logDate,
          name: activity.logMessage,
          // Include activity.type only if you want to show type, otherwise remove
          type: activity.type || "",
        }));
        setlogListCount(response.totalCount);
        setlogList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  // Split activities into two halves
  const midIndex = Math.ceil(logList.length / 2);
  const firstHalf = logList.slice(0, midIndex);
  const secondHalf = logList.slice(midIndex);

  return (
    <div className="w-full relative h-[80vh] max-h-[600px] bg-white shadow-md rounded-lg p-4 md:p-6 flex flex-col">
      {/* Title */}
      <h3 className="text-gray-700 font-semibold mb-4 text-center text-lg md:text-xl">
        Activity Logs
      </h3>

      {/* Scrollable Activity Logs */}
      <div className="flex-grow overflow-y-auto">
        {/* Mobile View: Single Column */}
        <div className="block md:hidden space-y-6">
          {logList.map((activity, index) => (
            <div key={index} className="relative flex items-start space-x-4">
              {/* Dot + Vertical Line */}
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 bg-[#E86B1B] rounded-full"></div>
                {index !== logList.length - 1 && (
                  <div className="w-0.5 bg-gray-300 h-10"></div>
                )}
              </div>
              {/* Activity Content */}
              <div>
                <span className="text-sm text-gray-500">{activity.date}</span>
                <strong className="block text-gray-700">{activity.name}</strong>
                {activity.type && (
                  <span className="text-sm text-gray-700">{activity.type}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Desktop View: Two Columns */}
        <div className="hidden md:grid md:grid-cols-2 gap-6 relative">
          {/* Left Column */}
          <div className="pr-6 relative">
            {firstHalf.map((activity, index) => (
              <div
                key={index}
                className="relative flex items-start space-x-4 mb-4"
              >
                {/* Dot + Vertical Line */}
                <div className="flex flex-col items-center">
                  <div className="w-3 h-3 bg-[#E86B1B] rounded-full"></div>
                  {index !== firstHalf.length - 1 && (
                    <div className="w-0.5 bg-gray-300 h-10"></div>
                  )}
                </div>

                {/* Activity Content */}
                <div>
                  <span className="text-sm text-gray-500">{activity.date}</span>
                  <strong className="block text-gray-700">
                    {activity.name}
                  </strong>
                  {activity.type && (
                    <span className="text-sm text-gray-700">
                      {activity.type}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Vertical Divider */}
          <div className="absolute top-0 bottom-0 left-1/2 w-0.5 bg-gray-300"></div>

          {/* Right Column */}
          <div className="pl-6">
            {secondHalf.map((activity, index) => (
              <div
                key={index}
                className="relative flex items-start space-x-4 mb-4"
              >
                {/* Dot + Vertical Line */}
                <div className="flex flex-col items-center">
                  <div className="w-3 h-3 bg-[#E86B1B] rounded-full"></div>
                  {index !== secondHalf.length - 1 && (
                    <div className="w-0.5 bg-gray-300 h-10"></div>
                  )}
                </div>

                {/* Activity Content */}
                <div>
                  <span className="text-sm text-gray-500">{activity.date}</span>
                  <strong className="block text-gray-700">
                    {activity.name}
                  </strong>
                  {activity.type && (
                    <span className="text-sm text-gray-700">
                      {activity.type}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Pagination - Visible for both mobile and desktop */}
      {logListCount > pageSize && (
        <div className="mt-4 flex justify-end">
          <PaginationComponent
            totalPages={Math.ceil(logListCount / pageSize)}
            currentPage={logListCurrentPage}
            onPageChange={HandlePageChange}
          />
        </div>
      )}
    </div>
  );
};

const ActivityLogPage = () => {
  return <ActivityLog />;
};

export default ActivityLogPage;
